import { useQuery } from '@tanstack/react-query'

import { isDenebEnabled } from '@/const/flags'
import { aspidaClient } from '@/lib/aspida'
import { QueryConfig } from '@/lib/react-query'
import { useProxyStore } from '@/providers/proxyStore/ProxyStoreContext'

import { cartKeyFactory } from './key'

const getCartItemCount = (storeCode: string | null) => {
  if (isDenebEnabled && storeCode) {
    return aspidaClient.v1.employee.proxy_stores
      ._storeCode(storeCode)
      .cart.count.$get()
  }
  return aspidaClient.v1.cart.count.$get()
}

type UseCartItemCountOptions = {
  config?: QueryConfig<typeof getCartItemCount>
}

export const useCartItemCount = ({ config }: UseCartItemCountOptions) => {
  const { storeCode } = useProxyStore()

  const queryConfig: QueryConfig<typeof getCartItemCount> = {
    ...config,
    queryKey: cartKeyFactory.itemCount(),
    queryFn: () => getCartItemCount(storeCode),
  }
  return useQuery(queryConfig)
}
